import { withInstall } from '@antdv/utils';
import APopconfirm from './src/Popconfirm';

export const Popconfirm = withInstall(APopconfirm);
export default Popconfirm;

export * from './src/interface';
export * from './src/props';
